import { FieldPath } from 'react-hook-form'

import { determineStateData } from 'commons/utils'
import { SarEdit } from '~bank-bsa-reporting/types'

export const updateStateField = (
  name: FieldPath<SarEdit>,
  country: string | undefined | unknown,
  setValue: (name: FieldPath<SarEdit>, value: any) => void,
  getValues: (name: FieldPath<SarEdit>) => any,
  clearErrors: (name: FieldPath<SarEdit>) => void
) => {
  if (typeof country === 'string') {
    const states = determineStateData(country)
    if (states.length === 1) {
      setValue(name, states[0].value)
    } else if (
      // check if state already set from states array, because user can select US state before selecting country
      // we do not want to undo that select on every country change
      states.find((el) => el.value === getValues(name)) === undefined
    ) {
      setValue(name, '')
    }

    clearErrors(name)
  }
}
